/**
 * Back-in-stock notification functionality.
 * Allows visitors to register their email to be notified when an out-of-stock product returns.
 */
(function () {
  'use strict';

  var modal = null;

  function createModal(triggerButton) {
    if (modal) {
      modal.remove();
    }

    var productHandle = triggerButton.dataset.productHandle;
    var t = {
      title: triggerButton.dataset.title,
      description: triggerButton.dataset.description,
      placeholder: triggerButton.dataset.placeholder,
      submit: triggerButton.dataset.submit,
      success: triggerButton.dataset.success,
      error: triggerButton.dataset.error,
      invalidEmail: triggerButton.dataset.invalidEmail,
      privacy: triggerButton.dataset.privacy,
    };

    modal = document.createElement('div');
    modal.className = 'back-in-stock-modal';
    modal.innerHTML =
      '<div class="back-in-stock-modal__content">' +
        '<button class="back-in-stock-modal__close" aria-label="Close">&times;</button>' +
        '<h3>' + t.title + '</h3>' +
        '<p>' + t.description + '</p>' +
        '<div class="back-in-stock-modal__input-group">' +
          '<input type="email" class="back-in-stock-modal__email field__input" placeholder="' + t.placeholder + '" required>' +
          '<button type="button" class="back-in-stock-modal__submit button button--primary">' + t.submit + '</button>' +
        '</div>' +
        '<p class="back-in-stock-modal__message" hidden></p>' +
        '<p class="back-in-stock-modal__privacy"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' + t.privacy + '</p>' +
      '</div>';
    document.body.appendChild(modal);

    var emailInput = modal.querySelector('.back-in-stock-modal__email');
    var submitButton = modal.querySelector('.back-in-stock-modal__submit');
    var message = modal.querySelector('.back-in-stock-modal__message');

    // Close handlers
    modal.querySelector('.back-in-stock-modal__close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', onEscape);

    // Submit handlers
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        submitRegistration();
      }
    });
    submitButton.addEventListener('click', submitRegistration);

    // Show modal
    modal.classList.add('is-visible');
    emailInput.focus();

    function submitRegistration() {
      var email = emailInput.value.trim();

      if (!email || !isValidEmail(email)) {
        showMessage(t.invalidEmail, 'error');
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = '...';

      var formData = new FormData();
      formData.append('email', email);
      formData.append('product_handle', productHandle);

      fetch('/a/proxy/back-in-stock/register', {
        method: 'POST',
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.success) {
            closeModal();
            triggerButton.hidden = true;

            if (window.MontisNotification) {
              window.MontisNotification.show({
                message: t.success,
                type: 'success',
                duration: 4000,
              });
            }
          } else {
            showMessage(data.error || t.error, 'error');
            submitButton.disabled = false;
            submitButton.textContent = t.submit;
          }
        })
        .catch(function () {
          showMessage(t.error, 'error');
          submitButton.disabled = false;
          submitButton.textContent = t.submit;
        });
    }

    function showMessage(text, type) {
      message.textContent = text;
      message.hidden = false;
      message.className = 'back-in-stock-modal__message back-in-stock-modal__message--' + type;
    }
  }

  function closeModal() {
    if (modal) {
      modal.classList.remove('is-visible');
      document.removeEventListener('keydown', onEscape);
      setTimeout(function () {
        if (modal) {
          modal.remove();
          modal = null;
        }
      }, 200);
    }
  }

  function onEscape(e) {
    if (e.key === 'Escape') closeModal();
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  document.querySelectorAll('.back-in-stock-notify__button').forEach(function (button) {
    button.addEventListener('click', function () {
      createModal(button);
    });
  });
})();
